const getTeamAbbreviation = (game, isHome) => {
  if (isHome) {
    return game && game.teams && game.teams.home && game.teams.home.team ? game.teams.home.team.abbreviation : "N/A";
  } else {
    return game && game.teams && game.teams.away && game.teams.away.team ? game.teams.away.team.abbreviation : "N/A";
  }
};

export { getTeamAbbreviation };
